import { Component, Injectable, OnDestroy, OnInit } from "@angular/core";
import { TranslateService } from "../../core/translation";
import { Environment } from "../../models/environment";
import { PersonalizationsService } from "../../base/services/personalizations/personalizations.service";
import { BehaviorSubject, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

export interface ComponentSubscription extends Component {
    _transParam?: boolean;
    translate?: () => void;
}

@Injectable()
export class LanguageService implements OnDestroy {
    public lang: string;
    public environment: Environment;
    public showLanguageSelector: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public operationLanguage: BehaviorSubject<string> = new BehaviorSubject<string>('');

    destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(
        private _translate: TranslateService,
        private _personalization: PersonalizationsService) {
        this.environment = this._personalization.sendEnv;

        this.operationLanguage.subscribe((lang: string) => {
            const hideLangSelect = this.environment.lang.hideSelect ? this.environment.lang.hideSelect : false;
            const forcedLanguage = this.environment.lang.force ? true : false;
            const shouldShowLangueSelector = this.environment.lang && this.environment.lang.active.length > 1 && !hideLangSelect && !forcedLanguage;
            if (lang) {
                this.lang = lang;
                this._translate.set(lang);
                this.showLanguageSelector.next(!!this.lang || shouldShowLangueSelector);
            }
        });
    }

    public subscribeToTranslationChange(component: ComponentSubscription): void {
        if (component) {
            if (component.translate) {
                component.translate();
            }

            if (component._transParam === undefined) {
                component._transParam = false;
            }

            this._translate?.onLangChange.pipe(takeUntil(this.destroy$)).subscribe((lang: string) => {
                this.lang = lang;

                if (component._transParam !== undefined) {
                    component._transParam = !component._transParam;
                }
                if (component.translate) {
                    component.translate();
                }
            });
        }
    }

    public setCurrentLanguage(): void {
        sessionStorage.setItem('currentLanguage', this._translate.lang);
    }

    public resetCurrentLanguage(): void {
        const language = sessionStorage.getItem('currentLanguage');

        if (language) {
            this._translate.set(language);
        }
    }

    ngOnDestroy(): void {
        this.operationLanguage.unsubscribe();
    }
}
